//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Ajuda() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Ajuda aos usuários a prevenir, reconhecer, diagnosticar e recuperar de erros
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve apresentar comunicações de erros que sejam claras, que indiquem qual foi o 
              erro cometido e qual deve ser a ação para conseguir se recuperar do erro e completar a tarefa desejada. Além disso, em todas as suas funções complexas o software 
              deve apresentar comunicações que instruam como o usuário pode executar aquela função de modo a prevenir a ocorrência de erros. Exemplo: No preenchimento de seu 
              formulário de cadastro, o usuário pode esquecer de preencher algum dado. Assim, quando o usuário tentar salvar essa ação, o software deve perguntar se ele preencheu 
              todos os dados e, quando o erro ocorrer, deve-se mostrar que ocorreu um erro, mostrar onde esse erro está no formulário e apresentar um exemplo de como o dado deve ser 
              preenchido. </strong> </p>
            <p align="justify"> <strong> A heurística Ajuda aos usuários a prevenir, reconhecer, diagnosticar e recuperar de erros apresenta um critério de análise, a saber: 
              Comunicações de auxílio ao usuário (C1). </strong> </p>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C1) As comunicações geradas por meio de erros do usuário indicam de forma clara e objetiva qual foi o erro cometido e o que o usuário deve fazer para conseguir 
                completar a sua tarefa? Indique o número de comunicações analisadas (N) e a quantidade de comunicações coerentes encontradas (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de comunicações analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P2.C1)   As funções chave do software e as funções complexas presentam instruções de uso durante o uso da função? Indique o número de funções analisadas (N) 
                e a quantidade de funções que apresentam instruções (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções analisadas:  &nbsp; </span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de funções que apresentam instruções: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P3.C1)   O software apresenta funções informativas que descrevem para o usuário o que determinada ação faz ou como determinado campo deve ser preenchido? 
                Indique o número de funções analisadas (N) e a quantidade de funções que apresentam instruções (Q). Exemplo: Em um formulário ter um ícone em cada campo 
                que ao ser clicado ou parar o mouse sobre o ícone aparece na tela uma explicação sobre o que é aquela informação requisitada e como deve ser preenchida. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de funções que apresentam instruções : &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            
           
            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
